import { render, staticRenderFns } from "./service_card_detail.vue?vue&type=template&id=00213f96&scoped=true"
import script from "./service_card_detail.vue?vue&type=script&lang=js"
export * from "./service_card_detail.vue?vue&type=script&lang=js"
import style0 from "./service_card_detail.vue?vue&type=style&index=0&id=00213f96&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00213f96",
  null
  
)

export default component.exports